import React from "react";
import Badge from "../components/shared/Badge";
import { Diamond, ArrowRight } from "lucide-react";
import image1 from "../images/gallery/a3.jpg";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-black text-white">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={image1}
          alt="Stainless profiles"
          className="w-full h-full object-cover opacity-30"
        />
      </div>

      {/* Content Container */}
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="max-w-6xl">
          <Badge>Premium Stainless Steel Profiles & Sheets</Badge>
          <h1 className="mt-6 text-3xl sm:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight">
            Architectural <span className="text-yellow-700">SS Profiles / Inlays & Trims</span>{" "}
            for Luxury Interiors
          </h1>
          <p className="mt-6 text-neutral-300 text-lg">
            Elevating spaces with timeless stainless steel elegance.
          </p>
          <p className="mt-0 text-neutral-300 text-lg">
            Crafted for interiors where sophistication meets lasting impression.
          </p>

          {/* CTA Buttons */}
          <div className="mt-10 flex flex-col sm:flex-row flex-wrap items-center gap-4">
            <a
              href="#products"
              className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-black bg-gradient-to-br from-yellow-300 to-amber-400 shadow-lg shadow-yellow-500/20 hover:brightness-110 transition"
            >
              Explore Products <Diamond className="h-4 w-4" />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-black bg-gradient-to-br from-yellow-300 to-amber-400 shadow-lg hover:brightness-110 transition"
            >
              Enquire Now <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
